export const getAuthHeaders = (token = null) => {
  const headers = {
    'Content-Type': 'application/json'
  };

  // Add Authorization header if a token is provided, regardless of environment
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  return headers;
};
